import { IconKey } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { SecretRow } from '../lib/connections';
import { day } from '../lib/time';
import { Button } from './ui/Button';

// One row of <ConnectionTokensPanel/>'s list: the `dashboard:<handle>` ref, the
// date it was saved, and the revoke affordance. Presenter — no query, no confirm
// state; the panel owns the dialog and this only asks for it via `onRevoke`.
// A vault read never yields plaintext, so there is no value to render here.

export function ConnectionTokenRow(props: {
  readonly row: SecretRow;
  readonly onRevoke: (row: SecretRow) => void;
}): JSX.Element {
  return (
    <li class="row-list__row" data-name={props.row.name}>
      <div class="row-list__lead">
        <span class="row-list__tile">
          <IconKey />
        </span>
        <div class="connections__lines">
          <code class="connections__ref">{props.row.name}</code>
          <span class="connections__date">{day(props.row.created_at)}</span>
        </div>
      </div>
      <Button variant="ghost" size="sm" onClick={() => props.onRevoke(props.row)}>
        {t('connections.revoke')}
      </Button>
    </li>
  );
}
